<template>
  <div class="account-information">
    <div class="a-i-left">
        <img src="../../assets/img/tu.jpg" alt="">
        <div class="station-name">{{ list.nickname | defaultValFilter }}</div>
        <div class="balance">
            <span class="text">余额:</span>
            <span class="money">￥ {{ list.balance | defaultValFilter }}</span>
        </div>
    </div>
    <div class="a-i-right">
        <div class="r-content">
            <div class="r-title">
                <span class="l-line"></span>
                <span class="title-t">基本资料</span>
            </div>
            <div style="clear:both;"></div>
            <div class="details-box">
                <div class="left">
                    <div class="content-box">
                        <!-- <span class="star">*</span> -->
                        <span class="name">客户名称：</span>
                        <span class="message">{{ list.nickname | defaultValFilter }}</span>
                        <div style="clear:both;"></div>
                    </div>
                    <div class="content-box">
                        <span class="name no-star">月结状态：</span>
                        <span class="message" v-if="list.customer_status==1">启用</span>
                        <span class="message" v-else-if="list.customer_status==2">禁用</span>
                        <div style="clear:both;"></div>
                    </div>
                </div>
                <div class="right">
                    <div class="content-box">
                        <!-- <span class="star">*</span> -->
                        <span class="name">联系电话：</span>
                        <span class="message">{{ list.phone_number | defaultValFilter }}</span>
                        <div style="clear:both;"></div>
                    </div>
                    <div class="content-box">
                        <span class="name email">邮箱：</span>
                        <span class="message">{{ list.email | defaultValFilter }}</span>
                        <div style="clear:both;"></div>
                    </div>
                </div>
                <div style="clear:both;"></div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
        list:{},
    };
  },
  mounted() {
    this.$nextTick(function() {
        this.getDataList();
    });
  },
  methods: {
    getDataList(){
        let params = {
            uid: localStorage.getItem("uid"),
            token: localStorage.getItem("token"),
            action:"getCustomerInfo",
        };
        this.$api({
            method: "post",
            url: "/api.php/Customer2/index",
            data: params,
            transformRequest: [
            data => {
                let ret = "";
                for (let it in data) {
                ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
                }
                return ret;
            }
            ]
        })
            .then(su => {
                if(su.data.code == 1){
                    this.list = su.data.list;
                } else if(su.data.code == 300) {
                    localStorage.clear(); 
                    this.$router.push('/login');
                    this.$message.warning(su.data.message);
                } else if (su.data.code == 900)  {
                } else {
                    this.$message.warning(su.data.message);
                }
            })
            .catch(err => {
        });
    },
  }
};
</script>

<style scoped lang="scss">
.account-information {
    height: 600px;
    .a-i-left {
        display: inline-block;
        width: 26%;
        height: 100%;
        border-right: 1px solid #ececec;
        vertical-align: top;
        img {
            width: 180px;
            height: 180px;
            border-radius: 50%;
            vertical-align: top;
            margin-top: 66px;
        }
        .station-name  {
            margin-top: 26px;
            color: #333333;
            font-size: 16px;
            // font-weight: 600;
        }
        .balance {
            margin-top: 10px;
            .text {
                color: #333333;
            }
            .money {
                color: #e80000;
                // font-weight: 600;
            }
        }
    }
    .a-i-right{
        display: inline-block;
        width: 68%;
        height: 100%;
        .r-content {
            margin-left: 15%;
            margin-top: 60px;
            .r-title {
                float: left;
                margin-bottom: 20px;
                span {
                    display: inline-block;
                }
                .l-line {
                    width: 5px;
                    height: 30px;
                    background-color: #0071bd;
                    margin-right: 10px;
                }
                .title-t {
                    vertical-align: top;
                    margin-top: 1px;
                    color: #333333;
                    font-size: 22px;
                }
            }
            .details-box {
                .left {
                    display: inline-block;
                    width: 40%;
                    float: left;
                    .content-box {
                        margin-top: 12px;
                        span {
                            float: left;
                            display: inline-block;
                        }
                        .star {
                            color: #e50000;
                            margin-right: 5px;
                            line-height: 44px;
                        }
                        .name {
                            color: #333333;
                            line-height: 44px;
                        }
                        .message {
                            color: #323433;
                            width: 60%;
                            height: 44px;
                            line-height: 44px;
                            background-color: #f3f4f6;
                            text-align: left;
                            padding-left: 10px;
                            font-size: 14px;
                        }
                        .no-star {
                            // margin-left: 6px;
                        }
                    }
                }
                .right {
                    width: 40%;
                    display: inline-block;
                    float: right;
                    margin-right: 16%;
                    .content-box {
                        margin-top: 12px;
                        span {
                            float: left;
                            display: inline-block;
                        }
                        .star {
                            color: #e50000;
                            margin-right: 5px;
                            line-height: 44px;
                        }
                        .name {
                            color: #333333;
                            line-height: 44px;
                        }
                        .message {
                            color: #333333;
                            width: 60%;
                            height: 44px;
                            line-height: 44px;
                            background-color: #f3f4f6;
                            text-align: left;
                            padding-left: 10px;
                        }
                        .email {
                            margin-left: 32px;
                        }
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/membershipManagement/accountInformation.vue